import { createAction } from '@reduxjs/toolkit';

export const fetchBackgroundsRequest = createAction('backgrounds/fetchBackgroundsRequest');
export const fetchBackgroundsSuccess = createAction('backgrounds/fetchBackgroundsSuccess');
export const fetchBackgroundsError = createAction('backgrounds/fetchBackgroundsError');

export const clearBackgrounds = createAction('backgrounds/clearBackgrounds');
